import { Pipe, PipeTransform } from '@angular/core';
import { GeneralHelpers } from '../helpers/general.helper';

@Pipe({
  name: 'prettyjson',
  pure: true,
  // eslint-disable-next-line
  standalone: false,
})
export class PrettyJsonPipe implements PipeTransform {
  transform(value: any, args: any[]): any {
    try {
      let valueForTransform = value;

      // EHQ-416: valid JSON is parsed as written; Python reprs (single
      // quotes, True/False/None) are normalized only when that fails. Text
      // that is not JSON-shaped keeps its own quotes and words.
      if (typeof value === 'string' && GeneralHelpers.isJSON(value)) {
        valueForTransform = GeneralHelpers.parseStructuredOutput(value);
      }

      return this.applyColors(
        valueForTransform,
        args[0],
        args[1],
        args[2],
      );
    } catch (e) {
      // EHQ-416: show the output as plain text rather than replacing it with
      // a made-up error object; applyColors still HTML-escapes it.
      console.warn('PrettyJsonPipe Invalid JSON:', value, e);
      return this.applyColors(String(value), args[0], args[1], false);
    }
  }

  private getThemeClass(value: string): string {
    if (value.startsWith('"')) {
      return value.endsWith(':') ? 'key' : 'string';
    }
    if (/^(true|false)$/.test(value)) {
      return 'boolean';
    }
    if (value === 'null') {
      return 'null';
    }
    return 'number';
  }

  applyColors(
    obj: any,
    showNumberLine: boolean = false,
    padding: number = 4,
    enableColors: boolean = true
  ) {
    let line = 1;

    if (typeof obj !== 'string') {
      obj = JSON.stringify(obj, undefined, 3);
    }

    // Handle HTML special characters
    obj = obj.replace(/[&<>]/g, (char: string | number) => {
      const entities: { [key: string]: string } = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
      };
      return entities[char];
    });

    if (enableColors) {
      // Split the complex regex into smaller parts
      const patterns = [
        { pattern: /"[^"]*"(\s*:)?/g, type: 'quoted' }, // Strings and keys
        { pattern: /\b(true|false)\b/g, type: 'boolean' }, // Booleans
        { pattern: /\bnull\b/g, type: 'null' }, // Null
        { pattern: /-?\d+(\.\d+)?([eE][+-]?\d+)?/g, type: 'number' }, // Numbers
      ];

      // Apply formatting for each pattern
      for (const { pattern } of patterns) {
        obj = obj.replace(pattern, (match: string) => {
          const themeClass = this.getThemeClass(match);
          return `<span class="${themeClass}">${match}</span>`;
        });
      }
    }

    return showNumberLine
      ? obj.replace(
        /^/gm,
        () =>
          `<span class="number-line pl-3 select-none">${String(line++).padEnd(
            padding
          )}</span>`
      )
      : obj;
  }
}
